module.exports = __webpack_public_path__ + "static/media/night-sky.1701d635.png";